/* Lapoche cart drawer: suggested products row. */
(function () {
  'use strict';
  if (window.lpSuggestLoaded) return;
  window.lpSuggestLoaded = true;

  function cartRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }

  function render(cart) {
    var wrap = document.querySelector('[data-lp-suggest]');
    if (!wrap || !cart || !cart.items) return;
    var inCart = {};
    cart.items.forEach(function (item) { inCart[String(item.product_id)] = true; });
    var shown = 0;
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-lp-suggest-card]'), function (card) {
      var hide = !!inCart[card.dataset.productId];
      card.hidden = hide;
      if (!hide) shown++;
    });
    wrap.hidden = !cart.item_count || shown === 0;
  }

  function refresh() {
    return fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-lp-suggest] select[data-lp-suggest-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var price = sel.closest('[data-lp-suggest-card]').querySelector('[data-lp-suggest-price]');
    if (opt && price && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lp-suggest-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-lp-suggest-card]');
    var input = card.querySelector('[data-lp-suggest-variant]');
    var id = input && Number(input.value);
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    fetch(cartRoute() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(refresh)
      .catch(function () {})
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('theme:cart:change', function (e) {
    render(e.detail && e.detail.cart);
  });

  fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(render)
    .catch(function () {});
})();